import { getImporteFacturable } from "./getImporteFacturable";
import { resolverPorcentajeAgencia } from "./resolverPorcentajeAgencia";

export const calcularImporteNetoIntermediario = (factura, clientes, intermediarios, pais, pctMap = null) => {
  if (!factura?.importe) return 0;
  // Base de comisión = importe FACTURABLE: el descuento de acuerdo (ej. OMNET 25%, ver 7.22) reduce
  // la base en el mismo punto donde antes la reducía la comisión del override. Sin descuento_acuerdo_pct,
  // getImporteFacturable devuelve el importe sin cambios → comportamiento idéntico a hoy. El % (vivo o
  // congelado, A3) se aplica sobre esta base VIVA — congelamos el %, no la base.
  const importeBase = getImporteFacturable(factura);
  if (importeBase <= 0) return 0;
  // Anti-doble-descuento (7.22 Paso 2): con descuento de acuerdo, el 25% ya salió como reducción de
  // base → la comisión de intermediario/agencia es 0 (no se resta una segunda vez).
  if ((parseFloat(factura.descuento_acuerdo_pct) || 0) > 0) return importeBase;
  // El % de agencia se resuelve en la fuente única (Fase A0); con pctMap (A3) lee el % congelado.
  const porcentajeComision = resolverPorcentajeAgencia(factura, clientes, intermediarios, pais, pctMap);
  const comision = (importeBase * porcentajeComision) / 100;
  return importeBase - comision;
};

export const calcularPorcentajeComisionIntermediario = (factura, clientes, intermediarios, pais, pctMap = null) => {
  if (!factura?.importe) return 0;
  // Anti-doble-descuento (7.22 Paso 2): con descuento de acuerdo, el % de intermediación es 0
  // (el 25% es descuento sobre la base, no comisión de intermediario).
  if ((parseFloat(factura.descuento_acuerdo_pct) || 0) > 0) return 0;
  // El % de agencia se resuelve en la fuente única (Fase A0); con pctMap (A3) lee el % congelado.
  return resolverPorcentajeAgencia(factura, clientes, intermediarios, pais, pctMap);
};

export const obtenerNombreIntermediario = (factura, clientes, intermediarios, pais) => {
  // Nombre del intermediario = la agencia del cliente (regla 10.7). El override por venta (OMNET) se
  // retiró en C-2 (7.22): OMNET corre por descuento, no cambia el nombre de la agencia.
  const cliente = clientes.find((c) => c.id === factura.client_id && c.pais === pais);
  if (!cliente?.agencia) return "DIRECTO";
  const intermediarioId = parseInt(cliente.agencia, 10);
  if (isNaN(intermediarioId)) return "DIRECTO";
  const intermediario = intermediarios.find((i) => i.id === intermediarioId && i.pais === pais);
  return intermediario?.nombre || "DIRECTO";
};
